const projects=[
    {
      "title": "YouTube Clone",
      "imageSrc": require("../images/projects/youTube.jpg"),
      "description": "Established a video platform reminiscent of YouTube, offering effortless video search and playback capabilities.",
      "skills": ["React", "Rapid-API", "Material-UI"],
      "demo": "https://youtube-clone-mastery.netlify.app/",
      "source": "https://github.com/himanshu060301/YoutubeClone/tree/master"
    },
    {
      "title": "EASYRESERVE",
      "imageSrc": require("../images/projects/booking.jpg"),
      "description": "Developed a hotel reservation app with the MERN stack. The app utilizes technologies including the Context API and JWT.",
      "skills": ["MERN", "JWT", "Context API"],
      "demo": "https://booking-app-pu9m.onrender.com/",
      "source": "https://github.com/himanshu060301/Booking_Repo"
    },
    {
      "title": "FILMFANATIC",
      "imageSrc": require("../images/projects/movies.png"),
      "description": "This Movie Review App lets users explore, review movies, and watch trailers and includes secure user authentication features.",
      "skills": ["React", "Mongo DB", "Spring Boot"],
      "demo": "https://movie-review-4vb0.onrender.com/",
      "source": "https://github.com/himanshu060301/Movie-Review/tree/master"
    },
    {
      "title": "Url-Shortner",
      "imageSrc": require("../images/projects/url-shortner.png"),
      "description": "This project is a URL shortener implemented using Node.js, EJS, and JWT.The project has been dockerized for seamless deployment.",
      "skills": ["Node.JS", "EJS", "JWT", "Docker"],
      "demo": "https://url-shortner-e39k.onrender.com/",
      "source": "https://github.com/himanshu060301/URL_Shortner"
    },
];

module.exports=projects;